( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('ContractCustomService', ContractCustomService);

    ContractCustomService.$inject = ['$http'];

    function ContractCustomService($http) {
        return {
            getDTO: getDTO,
            getDistinct: getDistinct,
            getPlannedShipmentsByContract: getPlannedShipmentsByContract,
            returnSaleContractByShipment: returnSaleContractByShipment,
            returnMinifiedContractById: returnMinifiedContractById,
            returnMinifiedSaleContractByShipment: returnMinifiedSaleContractByShipment,
            returnPurchaseContractByLot: returnPurchaseContractByLot,
            returnMinifiedContractForLotDetailModalByTypeAndLotId: returnMinifiedContractForLotDetailModalByTypeAndLotId,
            returnSaleContractByLot: returnSaleContractByLot,
            returnContracts: returnContracts,
            returnContractsByTypeAndStatus: returnContractsByTypeAndStatus,
            returnMinifiedContractsByType: returnMinifiedContractsByType,
            returnContractAuditById: returnContractAuditById,
            returnContractById: returnContractById,
            returnContractPricing: returnContractPricing,
            returnContractFixation: returnContractFixation,
            returnContractsShipments: returnContractsShipments,
            returnMinifiedContractsForInvoiceDialogByShipmentIdAndInvType: returnMinifiedContractsForInvoiceDialogByShipmentIdAndInvType,
            copyContract: copyContract,
            returnUnfixedContracts: returnUnfixedContracts,
            returnBookedContracts: returnBookedContracts,
            returnGrossEstimateContracts: returnGrossEstimateContracts,
            getContractQualityById: getContractQualityById,
            getUsedIncoTerms: getUsedIncoTerms,
            getUsedPaymentTerms: getUsedPaymentTerms,
            getUsedGrades: getUsedGrades,
            getUsedGrowths: getUsedGrowths
        };

        function getUsedGrowths(contractType) {
            var url = "api/contract/growths?contractType=" + contractType;
            return $http.get(url);
        }

        function getUsedGrades(contractType) {
            var url = "api/contact/grades?contractType=" + contractType;
            return $http.get(url);
        }

        function getUsedIncoTerms(contractType) {
            var url = "api/contact/incoterms?contractType=" + contractType;
            return $http.get(url);
        }

        function getUsedPaymentTerms(contractType) {
            var url = "api/contact/paymentterms?contractType=" + contractType;
            return $http.get(url);
        }

        function getDTO(id) {
            var url = "api/contracts/dto/" + id;
            return $http.get(url);
        }

        function getDistinct(type) {
            var url = "api/contracts/distinct/" + type;
            return $http.get(url);
        }

        function getPlannedShipmentsByContract(id) {
            var url = "api/contracts/planned-shipments/" + id;
            return $http.get(url);
        }

        function returnSaleContractByShipment( id ) {
            var url = "api/contracts/sale/shipment/" + id;
            return $http.get( url );
        }

        function returnMinifiedContractById(id) {
            var url = "api/contracts/minified/" + id;
            return $http.get(url);
        }

        function returnMinifiedSaleContractByShipment(id) {
            var url = "api/contracts/sale/shipment/minified/" + id;
            return $http.get(url);
        }

        function returnPurchaseContractByLot(lotId) {
            var url = "api/contracts/purchase/lot/" + lotId;
            return $http.get(url);
        }

        function returnMinifiedContractForLotDetailModalByTypeAndLotId(type, lotId) {
            var url = "api/contracts/minified/" + type + "/lot/" + lotId + "/detail-modal";
            return $http.get(url);
        }

        function returnSaleContractByLot(lotId) {
            var url = "api/contracts/sale/lot/" + lotId;
            return $http.get(url);
        }

        function returnContracts() {
            var url = "api/contracts/all";
            return $http.get(url);
        }

        function returnContractsByTypeAndStatus(type, status) {
            var url = "api/contracts/" + type + "/status/" + status;
            return $http.get(url);
        }

        function returnMinifiedContractsByType(type) {
            var url = "api/contracts/minified/" + type;
            return $http.get(url);
        }

        function returnContractAuditById(id) {
            var url = "jv/audit/contracts/" + id;
            return $http.get(url);
        }

        function returnContractById(id) {
            var url = "api/contracts/" + id;
            return $http.get(url);
        }

        function returnContractPricing(id) {
            var url = "api/contracts/" + id + "/pricing";
            return $http.get(url);
        }

        function returnContractFixation(id) {
            var url = "api/contracts/" + id + "/fixation";
            return $http.get(url);
        }

        function returnContractsShipments(shipmentId, invoiceType) {
            var url = "api/contracts/shipments/" + shipmentId + "?invoiceType=" + invoiceType;
            return $http.get(url);
        }

        function returnMinifiedContractsForInvoiceDialogByShipmentIdAndInvType(shipmentId, invoiceType) {
            var url = "api/contracts/minified/shipments/" + shipmentId + "?invoiceType=" + invoiceType;
            return $http.get(url);
        }

        function copyContract(id, body) {
            return $http({
                url: 'api/contracts/' + id + '/copy',
                method: 'POST',
                data: body,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function returnUnfixedContracts() {
            var url = "api/contracts/unfixed";
            return $http.get(url);
        }

        function returnBookedContracts( startDate, endDate, contractType, contractStatus ) {
            var url = "api/contracts/booked?startDate=" + startDate + "&endDate=" + endDate +
                "&purchase=" + contractType.purchase + "&sale=" + contractType.sale +
                "&draft=" + contractStatus.draft + "&issued=" + contractStatus.issued + "&complete=" + contractStatus.complete +
                "&signed=" + contractStatus.signed + "&cancelled=" + contractStatus.cancelled;
            return $http.get(url);
        }

        function returnGrossEstimateContracts(startDate, endDate, contractStatus, contractCat, contractSubCat) {
            var url = "api/contracts/gross-estimate?startDate=" + startDate + "&endDate=" + endDate +
                "&draft=" + contractStatus.draft + "&issued=" + contractStatus.issued + "&complete=" + contractStatus.complete +
                "&signed=" + contractStatus.signed + "&cancelled=" + contractStatus.cancelled +
                "&japan=" + contractCat.japan + "&tui=" + contractCat.tui +
                "&subCatJapan=" + contractSubCat.subCatJapan + "&subCatOutside=" + contractSubCat.subCatOutside +
                "&subCatPurchase=" + contractSubCat.subCatPurchase + "&subCatDirect=" + contractSubCat.subCatPurchase;
            return $http.get(url);
        }

        function getContractQualityById(id) {
            var url = "api/contracts/" + id + "/quality";
            return $http.get(url);
        }
    }
})();
